<template>
  <p v-if="validationMsg" class="error">
    {{ validationMsg }}
  </p>
</template>

<script>
export default {
  props: {
    validationMsg: {
      type: [Function, String],
      default: () => ""
    }
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: #f03d3d;
  font-size: 12px;
  margin: 0;
  margin-top: 2px;
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 0.3px;
}
</style>



// WEBPACK FOOTER //
// src/components/resuables/form-error.vue